import { atom } from 'recoil';

type StatusType = 'idle' | 'loading' | 'success' | 'error';

export interface PaymentStatusAtom {
  fetch: StatusType, 
  create: StatusType,
  submit: StatusType,
};

export const paymentStatusAtom = atom<PaymentStatusAtom>({
  key: 'paymentStatusAtom',
  default: {
    fetch: 'idle',
    submit: 'idle',
    create: 'idle'
  }
});

export const paymentDetailsAtom = atom({ 
  key: 'paymentDetailsAtom', 
  default: {} 
});

export const paymentErrorAtom =  atom({ 
  key: 'paymentErrorAtom', 
  default: {} 
});